import React from 'react'
import { Input, Card, Button } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useFormikContext, FieldArray } from 'formik'
import { FormField } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const GovernmentCertificationSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const titlePath = useFieldPath('sections.governmentCertification.title')
  const textPath = useFieldPath('sections.governmentCertification.text')
  const bulletsPath = useFieldPath('sections.governmentCertification.bullets')
  const notePath = useFieldPath('sections.governmentCertification.note')

  const bullets = get(values, bulletsPath, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>Título</label>
        <Input
          name={titlePath}
          value={get(values, titlePath, '')}
          onChange={handleChange}
          placeholder="Ex: Certificação reconhecida para transporte coletivo"
        />
      </FormField>

      <FormField>
        <label>Texto</label>
        <TextArea
          name={textPath}
          value={get(values, textPath, '')}
          onChange={handleChange}
          rows={3}
          placeholder="Texto descritivo da certificação governamental"
        />
      </FormField>

      <h4>Bullets</h4>
      <FieldArray name={bulletsPath}>
        {(arrayHelpers) => (
          <>
            {bullets.map((bullet, index) => (
              <div key={index} style={{ marginBottom: 8, display: 'flex', gap: 8 }}>
                <Input
                  name={`${bulletsPath}.${index}`}
                  value={bullet}
                  onChange={handleChange}
                  placeholder="Ex: Validade Nacional"
                />
                <Button
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => arrayHelpers.remove(index)}
                />
              </div>
            ))}
            <Button
              type="dashed"
              onClick={() => arrayHelpers.push('')}
              block
              icon={<PlusOutlined />}
              style={{ marginBottom: 16 }}
            >
              Adicionar Bullet
            </Button>
          </>
        )}
      </FieldArray>

      <FormField>
        <label>Nota</label>
        <TextArea
          name={notePath}
          value={get(values, notePath, '')}
          onChange={handleChange}
          rows={2}
          placeholder="Nota adicional sobre a certificação"
        />
      </FormField>
    </Card>
  )
}
